import { render, staticRenderFns } from "./PaymentStatusLabel.vue?vue&type=template&id=5b53e5c0&"
import script from "./PaymentStatusLabel.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports